import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { MSubHeader, MNavigation } from '../molecules';
import { setLanguage } from '../../redux/head/headActions';

class OHeader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			fixed: false,
		};

		this.bindHandlers();
		this.bindListeners();
	}


	bindHandlers() {
		this.handleLanguagePick = this.handleLanguagePick.bind(this);
	}

	bindListeners() {
		window.addEventListener('scroll', () => this.attachHeader()); // eslint-disable-next-line
	}

	attachHeader() {
		this.setState({ fixed: window.scrollY > 350 });
	}
	handleLanguagePick(language) {
		this.props.setLanguage(language);
		window.location.reload();
	}

	render() {
		const cName = this.state.fixed ? 'fixed' : '';
		const lName = this.state.fixed ? 'scrolled-down' : '';

		return (
			<header className={`o-header ${cName}`}>
				<div className="a-gradient-header-band" />
				<MSubHeader
					lang={this.props.lang}
					onClick={this.handleLanguagePick}
				/>
				<MNavigation theme={this.props.theme} className={lName} />
			</header>
		);
	}
}

OHeader.propTypes = {
	theme: PropTypes.string,
	lang: PropTypes.string,
	setLanguage: PropTypes.func.isRequired,
};

OHeader.defaultProps = {
	theme: undefined,
	lang: '',
};

export default connect(null, {
	setLanguage,
}, null, { pure: false })(OHeader);



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.header.js